import React, { useMemo } from 'react';
import { Card, Button } from 'antd';
import styles from './s.module.less';

interface MatchingProviderProps {
    treatmentOptions: { label: string; value: string }[];
    treatment: string;
    onEdit?: () => void;
}

const MatchingProvider: React.FC<MatchingProviderProps> = ({ treatmentOptions, treatment, onEdit }) => {
    const treatmentText = useMemo(() => {
        if (!treatment || treatment.length === 0) {
            return '';
        }
        return treatment.split(',').map((item) => treatmentOptions.find((option) => option.value === item)?.label).join(', ');
    }, [treatmentOptions, treatment]);
    return (
        <Card className={styles.infoCard} bordered={false}>
            <div className={styles.header}>
                <span className={styles.title}>Filter by treatment</span>
                <Button onClick={onEdit}>Edit</Button>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>Treatment</div>
                <div className={styles.value}>{treatmentText}</div>
            </div>
        </Card>
    );
};

export default MatchingProvider;
